import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalHandoff } from '@/pages/workspaces/transactional/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/transactional` URL. Not migrated, the embedded app serves it; migrated, it
 * forwards to the Hydra list. The resolver belongs here: this URL keeps the `journeys` segment, so
 * a `/workspaces/last` sentinel has to resolve before the embedded app mounts on it.
 */
function JourneysTransactionalIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysTransactionalHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/transactional/')({
  component: JourneysTransactionalIndexRoute,
});
